import React from "react";
import KaDialog from "./KaDialog";
import Siegel from "../../assets/siegel2025.png";
import { Box, Typography, makeStyles } from "@material-ui/core";
import { useTheme } from "@material-ui/styles";
import useScreensize from "../../hooks/useScreensize";

const useStyles = makeStyles(theme => ({
    img: {
        backgroundSize: "auto 90%",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        [theme.breakpoints.up("sm")]: {
            backgroundSize: "90% auto",
        },
    },
    paragraph: {
        margin: theme.spacing(3, 0)
    }
}));

const KaSiegel = ({ open, close }) => {
    const classes = useStyles();
    const { xs, sm, md, lg, xl } = useScreensize();
    const theme = useTheme();

    return (
        <>
            <KaDialog open={open} close={close}>
                <>
                    <Box
                        display="flex"
                        flexDirection={xs ? "column" : "row"}
                        p={{ sm: 3 }}
                        height={xs ? undefined : sm ? 780 : 780}
                    >
                        <Box
                            p={3}
                            className={classes.img}
                            style={{ backgroundImage: "url(" + Siegel + ")" }}
                            flexGrow={1}
                            bgcolor={theme.palette.primary.main}
                            flexShrink={1}
                            flexBasis={xs ? "auto" : "0px"}
                            height={xs ? 400 : undefined}
                            mr={{ sm: 3 }}
                        ></Box>
                        <Box
                            color="white"
                            p={{ xs: 3, sm: 4 }}
                            flexGrow={1}
                            bgcolor={theme.palette.primary.main}
                            flexShrink={1}
                            flexBasis={xs ? "auto" : "0px"}
                        >
                            <Typography variant="h5" component="h3">
                                Wir sind stolz!
                            </Typography>
                            <Typography variant="body1" className={classes.paragraph}>
                                Steffen Kämmerer Steuerberater wurde auch 2025 wieder vom Handelsblatt als „Bester Steuerberater“ im Bereich Baugewerbe / Handwerk ausgezeichnet.
                            </Typography>
                            <Typography variant="body1" className={classes.paragraph}>
                                Nach den Auszeichnungen in 2019 und 2022 freuen wir uns besonders, als einziger Steuerberater aus Kaiserslautern diese Ehre in Empfang nehmen zu dürfen.
                                Für uns ist diese Auszeichnung weit mehr als nur ein Siegel. Sie ist ein Statement unserer Philosophie: Qualität und Expertise zählen, besonders dort, wo es wirklich komplex wird. Denn wer in diesen Bereichen erfolgreich sein will, benötigt nicht nur standardisierte Lösungen, sondern maßgeschneiderte Beratung auf Spitzenniveau.
                            </Typography>
                            <Typography variant="body1" className={classes.paragraph}>
                                Ein herzliches Dankeschön gilt unseren Mandanten, die uns ihr Vertrauen schenken und uns tagtäglich herausfordern, immer besser zu werden. Auf viele weitere Erfolge!
                            </Typography>
                        </Box>
                    </Box>
                </>
            </KaDialog>
        </>
    );
};

export default KaSiegel;
